module.exports = __webpack_public_path__ + "img/liyonggongdifangan.f6c1d4c7.svg";